module.exports = __webpack_public_path__ + "bradavice_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_1_before.jpg
// module id = 930
// module chunks = 0